/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

console.log("✅ custom.js is loaded");

(function () {
  function enforceTermsAgreement() {
    const checkoutBtn = document.querySelector('button[name="checkout"]');
    const termsCheckbox = document.getElementById('acceptance');

    if (checkoutBtn && termsCheckbox && !checkoutBtn.classList.contains('terms-listener-added')) {
      checkoutBtn.addEventListener('click', function (e) {
        if (!termsCheckbox.checked) {
          e.preventDefault();
          alert("購入を続けるには、利用契約に同意してください。");
        }
      });
      // Mark as already handled to avoid duplicate listeners
      checkoutBtn.classList.add('terms-listener-added');
    }
  }

  // Run once
  enforceTermsAgreement();

  // Watch for changes (e.g., AJAX-loaded cart or buttons)
  const observer = new MutationObserver(enforceTermsAgreement);
  observer.observe(document.body, { childList: true, subtree: true });
})();